<template>
  <div class="merdeka-warpper">
    <div class="bg-white ">

      <div class="flex align-center  flex-wrap margin-top-sm">
        <div class="poll-item margin-right">
          <div class="item-title active1"><img src="../../assets/img/my1.png" alt="">户数调查</div>
          <div class="item-info">
            <div class="item-num">
              <p>合计户数</p>
              <h3>{{ zongHuShu }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>整体同意(户)</p>
              <h3>{{ tongYiHuShu }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>同意率</p>
              <h3>{{ tongYiBiLvZongGai }}%</h3>
            </div>
          </div>
        </div>
        <!--        <div class="poll-item">-->
        <!--          <div class="item-title active2"><img src="../../assets/img/my2.png" alt="">串数调查</div>-->
        <!--          <div class="item-info">-->
        <!--            <div class="item-num">-->
        <!--              <p>合计串数</p>-->
        <!--              <h3>{{ zongChuanShu }}</h3>-->
        <!--            </div>-->
        <!--            <i></i>-->
        <!--            <div class="item-num">-->
        <!--              <p>串同意（串)</p>-->
        <!--              <h3>{{ tongYiChuanShu }}</h3>-->
        <!--            </div>-->
        <!--            <i></i>-->
        <!--            <div class="item-num">-->
        <!--              <p>同意率</p>-->
        <!--              <h3>{{ tongYiBiLvChuan }}%</h3>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="poll-item">-->
        <!--          <div class="item-title active3"><img src="../../assets/img/my3.png" alt="">单元调查</div>-->
        <!--          <div class="item-info">-->
        <!--            <div class="item-num">-->
        <!--              <p>合计单元</p>-->
        <!--              <h3>{{ zongDanYuanShu }}</h3>-->
        <!--            </div>-->
        <!--            <i></i>-->
        <!--            <div class="item-num">-->
        <!--              <p>单元同意（单元）</p>-->
        <!--              <h3>{{ tongYiDanYuanShu }}</h3>-->
        <!--            </div>-->
        <!--            <i></i>-->
        <!--            <div class="item-num">-->
        <!--              <p>同意率</p>-->
        <!--              <h3>{{ tongYiBiLvDanYuan }}%</h3>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="poll-item">
          <div class="item-title active4"><img src="../../assets/img/my4.png" alt="">未取得联系</div>
          <div class="item-info">
            <div class="item-num">
              <p>未取得联系</p>
              <h3>{{ weiQuDeLianXi }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>占比</p>
              <h3>{{ weiQuDeLianXiBiLv }}%</h3>
            </div>
          </div>
        </div>

      </div>
      <div class="margin-bottom-sm flex align-center justify-between">
        <twoLevel @SearchInfo="SearchInfo"/>
        <el-button type="primary" @click="merdekaDialog = true">新增民调</el-button>
      </div>
      <el-table
        :data="merdekaList"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号">
        </el-table-column>
        <el-table-column label="调查小区" prop="xiaoqu_name"></el-table-column>
        <el-table-column label="民调主体" prop="mindiaozhuti"></el-table-column>
        <el-table-column label="民调周期" prop="username">
          <template slot-scope="scope">
            <div>
              {{ scope.row.start_time }} ~ {{ scope.row.end_time }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="调查数量" prop="diaocha_num"></el-table-column>
        <el-table-column label="同意比例" prop="tongyi_bili">
          <template slot-scope="scope">
            <div>
              {{ (scope.row.tongyi_bili * 100).toFixed(2) }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="400">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                size="small"
                type="primary"
                @click="editItem(scope.row)"
              >编辑
              </el-button>

              <el-button
                size="small"
                type="primary"
                @click="rangeItem(scope.row.id,scope.row.xiaoqu_id,scope.row.xiangmu_id)"
              >民调范围
              </el-button>
              <el-button
                size="small"
                type="primary"
                @click="resultItem(scope.row.id)"
              >民调结果
              </el-button>
              <el-button
                size="small"
                type="primary"
                v-if="user.power !== 6"
                @click="deleteItem(scope.row.id)"
              >删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="merdekaList.length > 0"
        class="page-all"
        background
        @current-change="duLiMinDiaoList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <merdekaDialog
      :setId="setId"
      :setItem="setItem"
      :merdekaDialog="merdekaDialog"
      @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import twoLevel from "@/components/two-level";
import merdekaDialog from "@/views/pages/dialog/merdekaDialog";
import {duLiMinDiao, duLiMinDiaoDel, duLiMinDiaoList} from "@/api/merdeka";
import {zhDate} from "@/utils/utils";

export default {
  name: "merdeka-center",
  data() {
    return {
      zongHuShu: 0,
      tongYiHuShu: 0,
      tongYiBiLvZongGai: 0,
      zongChuanShu: 0,
      tongYiChuanShu: 0,
      tongYiBiLvChuan: 0,
      zongDanYuanShu: 0,
      tongYiDanYuanShu: 0,
      tongYiBiLvDanYuan: 0,
      weiQuDeLianXi: 0,
      weiQuDeLianXiBiLv: 0,

      project: 0,
      community: 0,
      page: 1,
      limit: 10,
      total: 0,
      merdekaList: [],
      setId: 0,
      setItem: {},
      merdekaDialog: false,
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "独立民调", false);
    this.duLiMinDiaoList()
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {
    merdekaDialog,
    twoLevel
  },
  methods: {
    async SearchInfo(val) {
      this.project = val.project
      this.community = val.community
      let _data = await duLiMinDiao(
        val.project,
        val.community
      )

      this.tongYiBiLvZongGai = (_data.data.tongYiBiLvZongGai * 100).toFixed(2)
      this.tongYiHuShu = _data.data.tongYiHuShu
      this.weiQuDeLianXi = _data.data.weiQuDeLianXi
      this.weiQuDeLianXiBiLv = (_data.data.weiQuDeLianXiBiLv * 100).toFixed(2)
      this.zongHuShu = _data.data.zongHuShu
      await this.duLiMinDiaoList()
    },
    //  查看结果
    resultItem(id) {
      this.$router.push('/home/merdeka-center-result/' + id)
    },
    //  查看范围
    rangeItem(id, cid, pid) {
      this.$router.push('/home/merdeka-center-range/' + id + '/' + cid + '?pid=' + pid)
    },
    //  员工信息编辑后回调
    cancelDialog(val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.merdekaDialog = false;
        this.duLiMinDiaoList();
      } else {
        this.setId = 0;
        this.setItem = {};
        this.merdekaDialog = false;
      }
    },
    //  删除账号
    deleteItem(id) {
      this.$confirm('您确定要删除该独立民调吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await duLiMinDiaoDel(id);
      if (this.merdekaList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.duLiMinDiaoList();
      this.$message.success(_state.info);
    },
    //  编辑
    editItem(obj) {
      this.setItem = obj;
      this.setId = obj.id;
      this.merdekaDialog = true;
    },
    //  获取列表
    async duLiMinDiaoList() {
      let _list = await duLiMinDiaoList(this.community, this.page, this.limit)
      _list.data.map(item => {
        item.start_time = zhDate(new Date(item.start_time).getTime())
        item.end_time = zhDate(new Date(item.end_time).getTime())
      })
      this.merdekaList = _list.data
      this.total = _list.total_number

    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.poll-item {
  flex-basis: 24%;
  height: 170px;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 19px 0px rgba(175, 181, 193, 0.47);
  border-radius: 8px;

  .item-title {
    display: flex;
    align-items: center;
    padding-left: 20px;
    height: 40px;
    font-size: 18px;
    color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    &.active1 {
      background-color: #1bb2cd;
    }

    &.active2 {
      background-color: #ffaf25;
    }

    &.active3 {
      background-color: #42922a;
    }

    &.active4 {
      background-color: #616161;
    }

    &.active5 {
      background-color: #1bb2cd;
    }

    &.active6 {
      background-color: #bf984c;
    }

    &.active7 {
      background-color: #2587ff;
    }

    &.active8 {
      background-color: #e15757;
    }

    img {
      margin-right: 10px;
    }
  }

  .item-info {
    display: flex;
    align-items: center;
    height: 130px;

    &.total-all {
      justify-content: center;
      font-size: 16px;

      b {
        font-size: 32px;
        margin-right: 5px;
      }
    }

    .item-num {
      width: 48%;
      min-height: 52px;
      text-align: center;

      p {
        font-size: 14px;
        color: #999;
        line-height: 150%;
      }

      h3 {
        font-size: 24px;
        line-height: 150%;
      }
    }

    i {
      display: block;
      width: 1px;
      height: 52px;
      border: dashed 1px #cccccc;
      opacity: 0.5;
    }
  }
}

</style>
